import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_PRIVACY: MijnRoute = {
    path: 'privacy',
    navigationEvent: 'toPrivacy',
    regex: /^\/zelf-regelen\/privacy$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent',
    internalPath: '/privacy'
};
